import {Observable, Subscription} from 'rxjs';

import IPlaybackStore from '../Interfaces/IPlaybackStore';

const subscribeToPlayTap = (
    playPauseTap$: Observable<void>,
    playbackStore: IPlaybackStore
): Subscription =>
    playPauseTap$
        .subscribe(() =>
            playbackStore.value.isPlaying ?
                playbackStore.actions.pause() :
                playbackStore.actions.play()
        );

export default subscribeToPlayTap;